import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "./app/app.component";
import {appConfig} from "./app/app.config";
import * as Sentry from "@sentry/angular";

if (environment.name != "local") {
  enableProdMode();
  // Init Sentry, pointing to the fasten-connect-stitch project
  let isProd = environment.name === "production"
  Sentry.init({
    dsn: "https://fab87f90d0799c5ef57a6990c83a4329@o4504673495482368.ingest.us.sentry.io/4509928258666496",
    integrations: [
      Sentry.browserTracingIntegration(),
      isProd ? Sentry.replayIntegration() : Sentry.replayIntegration({maskAllText: false, blockAllMedia: false}),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    environment: environment.short_name
  });
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
